import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { AdminRouteNames } from '@enums';
import { useSettings } from '@hooks/useSettings';
import classes from './AdminSidebar.module.css';

export const AdminSidebar = () => {
  const location = useLocation();
  const { data: settings } = useSettings();

  const routes = useMemo(
    () => [
      { path: `/${settings.adminPath}/manage-users`, label: AdminRouteNames.MANAGE_USERS, show: true },
      { path: `/${settings.adminPath}/manage-declarants`, label: AdminRouteNames.MANAGE_DECLARANTS, show: true },
      { path: `/${settings.adminPath}/manage-transaction-types`, label: AdminRouteNames.MANAGE_TRANSACTION_TYPES, show: true },
      { path: `/${settings.adminPath}/manage-templates`, label: AdminRouteNames.MANAGE_TEMPLATES, show: true },
      { path: `/${settings.adminPath}/manage-charts`, label: AdminRouteNames.MANAGE_CHARTS, show: true },
      { path: `/${settings.adminPath}/manage-batches`, label: AdminRouteNames.MANAGE_BATCHES, show: true },
      { path: `/${settings.adminPath}/manage-transits`, label: AdminRouteNames.MANAGE_TRANSITS, show: true },
      { path: `/${settings.adminPath}/manage-tsds`, label: AdminRouteNames.MANAGE_TEMPORARY_STORAGE, show: true },
      { path: `/${settings.adminPath}/manage-customs-errors`, label: AdminRouteNames.MANAGE_CUSTOMS_ERRORS, show: true },
      { path: `/${settings.adminPath}/manage-catalogs`, label: AdminRouteNames.MANAGE_CATALOGS, show: settings.isCatalogsTestEnv },
      { path: `/${settings.adminPath}/customs-systems`, label: AdminRouteNames.CUSTOMS_SYSTEMS, show: true },
      { path: `/${settings.adminPath}/request-observability`, label: 'Request observability', show: true },
    ],
    [settings.isCatalogsTestEnv],
  );

  return (
    <nav className={classes.navbar}>
      {routes
        .filter((route) => route.show || route.show === undefined)
        .map((route) => {
          const isActive = route.path === `/${location.pathname.split('/')[1]}/${location.pathname.split('/')[2]}`;
          const linkClassName = isActive ? `${classes.link} ${classes.linkActive}` : classes.link;

          return (
            <Link className={linkClassName} to={route.path} key={route.label}>
              <span>{route.label}</span>
            </Link>
          );
        })}
    </nav>
  );
};
